import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a6a0434"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: `customerdictionary-items-modal`,
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": `customerdictionary-items-modal-title`,
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-lg",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: `customerdictionary-items-modal-title`
  }, " Dictionary Items "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1))
const _hoisted_5 = { class: "table w-100" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-dark" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", { width: "60" })
  ])
], -1))
const _hoisted_7 = { class: "table-primary" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "fixed-height" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value", "onBlur"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]

import { computed, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { DictionaryItem } from "@/models";
import { useToast } from "vue-toastification";
import _ from "lodash";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerDictionaryItemsModal',
  setup(__props) {

const store = useStore();
const toasted = useToast();

const actProperty: any = inject('actProperty');

const newItem = ref(new DictionaryItem());

const currentItemsSorted = computed(() => store.getters['customerdictionary/currentItemsSorted']);

const setActiveItem = (item: DictionaryItem): void => {
  store.commit('customerdictionary/setActiveItem', item);
};

const addItem = (item: DictionaryItem): Promise<any> => {
  return store.dispatch('customerdictionary/addItem', item);
};

const updateItem = (item: DictionaryItem): Promise<any> => {
  return store.dispatch('customerdictionary/updateItem', item);
};

const removeItem = (item: DictionaryItem): Promise<any> => {
  return store.dispatch('customerdictionary/removeItem', item);
};

const reset = () => {
  newItem.value = new DictionaryItem();
};

const add = async () => {
  newItem.value.slug = _.snakeCase(newItem.value.name);
  addItem(newItem.value)
      .then(() => setActiveItem(newItem.value))
      .then(() => toasted.success(`Added "${newItem.value.name}"`))
      .then(() => reset())
      .catch((err: any) => {
        actProperty.displayError(err);
      });
};

const updateName = async ($event: Event, item: DictionaryItem) => {
  const input = $event.target as HTMLInputElement;
  item.name = input.value;
  updateItem(item).catch((err: any) =>
    actProperty.displayError(err)
  );
};

const remove = async (item: DictionaryItem) => {
  actProperty
    .confirmPrompt()
    .then(() => removeItem(item))
    .then(() => toasted.success(`Removed "${item.name}"`))
    .then(() => setActiveItem(new DictionaryItem()))
    .then(() => reset())
    .catch((err: any) => actProperty.displayError(err));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newItem.value.slug) = $event)),
                  placeholder: "Auto-generated",
                  readonly: "",
                  autocomplete: "off"
                }, null, 512), [
                  [_vModelText, newItem.value.slug]
                ])
              ]),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  onKeyup: _withKeys(add, ["enter"]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newItem.value.name) = $event)),
                  placeholder: "Required",
                  autocomplete: "off"
                }, null, 544), [
                  [_vModelText, newItem.value.name]
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: add,
                  disabled: !newItem.value.name.length
                }, _hoisted_10, 8, _hoisted_8)
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentItemsSorted.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `${item.slug}`
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    class: "form-control",
                    value: item.slug,
                    readonly: "",
                    autocomplete: "off"
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("input", {
                    class: "form-control",
                    value: item.name,
                    onBlur: ($event: any) => (updateName($event, item)),
                    autocomplete: "off"
                  }, null, 40, _hoisted_13)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    onClick: ($event: any) => (remove(item))
                  }, _hoisted_16, 8, _hoisted_14)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})